import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { LoaderInterfaceState } from '../../store/state/loader.state';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css'],
  standalone: false
})
export class LoaderComponent implements OnInit {
  visibility: number;
  timeoutId: any|null;
  brand?: string;

  constructor(
      private store: Store<any>,
      private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.brand = environment.data.brand;
    this.visibility = 0;
    this.timeoutId = null;
    this.store.pipe(select(ConstsHelper.REDUCER_LOADER)).subscribe((response: LoaderInterfaceState) => {
      if (response.visibility != null) {
        if (response.visibility > 0 || (response.visibility < 0 && this.visibility > 0)) {
          this.visibility += response.visibility;
          if (this.timeoutId) {
            clearTimeout(this.timeoutId);
          }
          this.cdr.detectChanges();
          if (this.visibility > 0) {
            this.timeoutId = setTimeout(
                function() {
                  this.visibility = 0;
                  this.timeoutId = null;
                  this.cdr.detectChanges();
                }.bind(this),
                3000
            );
          }
        }
      }
    });
  }
}
